<template>
  <div class="small-filter-row">
    <div class="filter-container">
      <div class="filter-tabs" :class="{ 'skewed': isSkewedTheme }">
        <BButton  v-for="option in options"
                  :key="option.value"
                  :disabled="disabled"
                  class="filter-tab"
                  :class="{
                    'active': modelValue === option.value,
                    'skewed': false && isSkewedTheme
                  }"
                  @click="handleSelect(option.value)">
          <span class="tab-content" :class="{ 'skewed': isSkewedTheme }">
            {{ option.label }}
          </span>
        </BButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Plus } from 'lucide-vue-next';

export default {
  name: 'RadioButtonGroup',

  props: {
    disabled: { type: Boolean, default: false },
    modelValue: { type: String, default: null },
    options: { type: Array, default: () => [
      { value: 'all', label: 'All Details' },
      { value: 'medium', label: 'Medium' },
      { value: 'minimal', label: 'Minimal' }
    ]}
  },

  components: {
    Plus
  },

  emits: ['update:modelValue', 'add-filter'],

  computed: {
    ...mapGetters('app', ['isSkewedTheme'])
  },

  methods: {
    handleSelect(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.small-filter-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding-top: 20px;
}

.filter-container {
  display: flex;
  align-items: center;
  gap: 24px;
}

.filter-tabs {
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 0 11px 0 0;

  &.skewed {
    transform: skewX(var(--target-skew-angle-inverse));
  }
}

.btn:disabled, .btn.disabled{
  background-color: none !important;
}

.filter-tab {
  border: none;
  border-bottom: 2px solid transparent;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.15s;
  margin-right: -11px;
  background-color: var(--custom-black-10);

  &:hover {
    background-color: var(--custom-black-20);
  }

  &.active {
    background-color: #38425160;
    border-bottom-color: var(--color-foreground);
  }

  &.skewed {
    transform: skewX(var(--target-skew-angle-inverse));
  }
}
[data-bs-theme="dark"] {
  .filter-tab {
    background-color: var(--navbar-bg);

    &.active {
      background-color: var(--navbar-item-active-bg);
    }
  }
}
.tab-content {
  display: flex;
  align-items: center;
  gap: 2px;
  font-family: 'BMWTypeNext Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--color-muted-foreground);
  white-space: nowrap;
  border: none;

  .filter-tab.active & {
    color: var(--color-foreground);
  }

  &.skewed {
    transform: skewX(var(--target-skew-angle)) scaleY(1.1247);
  }
}
</style>
